/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Ruian_LevelInputs */

const cs_form_ruian_level = /** @type {(inputs: Form_Ruian_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Úroveň RÚIAN`)
};

const en_form_ruian_level = /** @type {(inputs: Form_Ruian_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RÚIAN level`)
};

/**
* | output |
* | --- |
* | "RÚIAN level" |
*
* @param {Form_Ruian_LevelInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_ruian_level = /** @type {((inputs?: Form_Ruian_LevelInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Ruian_LevelInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_ruian_level(inputs)
	return cs_form_ruian_level(inputs)
});